"use strict";
import _ from 'lodash';

// module.exports.propsToDiff = {};

export const getInitialState = function getInitialState() {
	return _.keyBy(_.get(window, ['gData', 'redux', 'collections', 'gameScoreAssessmentCollection', 'list'], []), 'gameScoreAssessmentId');
};
